import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Table from "./Table";
import Filter from "./Filter";

const MRM = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      

      <div className="Sample_Report_Filter_div">
        <Filter setShow={setShow}/>
      </div>

      <div className="report_table_div">
        <Table />
      </div>

      <Common_Report_Offcanvas
        title={"MRM Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default MRM;
